import { render, staticRenderFns } from "./PlayDatesList.vue?vue&type=template&id=18d68224&"
import script from "./PlayDatesList.vue?vue&type=script&lang=js&"
export * from "./PlayDatesList.vue?vue&type=script&lang=js&"
import style0 from "./PlayDatesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports